import { Box, Center, chakra, Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';

export enum TagSize {
  medium,
  small,
}

interface Props {
  tags: Array<string | null>;
  tagColor?: string;
  size?: TagSize;
}

const TagsRow: FC<Props> = ({ tags, tagColor, size = TagSize.medium, ...props }) => {
  if (tags.length === 0) return null;
  const height = size === TagSize.medium ? '24px' : '19px';
  const fontSize = size === TagSize.medium ? '16px' : '12px';

  return (
    <Flex h={height} flexWrap="wrap" overflow="hidden" {...props}>
      {tags.map((tag, index) => (
        <Box
          bgColor={tagColor ?? '#000'}
          h={height}
          borderRadius="6px"
          px="8px"
          mr="5px"
          key={index}
        >
          <Center h="100%">
            <Text fontSize={fontSize} color="white">{tag}</Text>
          </Center>
        </Box>
      ))}
    </Flex>
  );
};

export default chakra(TagsRow);
